var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJamaica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.874C24.8366 32.874 32 25.7106 32 16.874C32 8.03747 24.8366 0.874023 16 0.874023C7.16344 0.874023 0 8.03747 0 16.874C0 25.7106 7.16344 32.874 16 32.874Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.741 4.18152C23.043 2.10771 19.6658 0.874023 16 0.874023C12.3341 0.874023 8.95685 2.10777 6.25891 4.18152L16 13.9225L25.741 4.18152Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30744 7.13344C1.23375 9.83138 0 13.2086 0 16.8744C0 20.5403 1.23375 23.9176 3.3075 26.6156L13.0486 16.8744L3.30744 7.13344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25891 29.5669C8.95691 31.6407 12.3341 32.8744 16 32.8744C19.6658 32.8744 23.043 31.6406 25.741 29.5669L16 19.8259L6.25891 29.5669Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6924 26.6154C30.7662 23.9175 31.9999 20.5403 31.9999 16.8744C31.9999 13.2086 30.7662 9.83138 28.6924 7.13344L18.9514 16.8744L28.6924 26.6154Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamaica);
export default __webpack_public_path__ + "static/media/jamaica.a951491a.svg";
export { ForwardRef as ReactComponent };